export enum StoreStatus {
  Draft = 'draft',
  PublishedForTest = 'published_for_test',
  Published = 'published',
  Archived = 'archived'
}

/** Values are translation keys under the root `shared` section: render them with the `transloco` pipe or `TranslocoService.translate()`. */
export const storeStatusLabels: Record<StoreStatus, string> = {
  [StoreStatus.Draft]: 'shared.storeStatus.draft',
  [StoreStatus.PublishedForTest]: 'shared.storeStatus.published_for_test',
  [StoreStatus.Published]: 'shared.storeStatus.published',
  [StoreStatus.Archived]: 'shared.storeStatus.archived'
};

/** A session list filtered by status, `all` for every status. */
export type StoreStatusFilter = StoreStatus | 'all';

/**
 * Chips for filtering a session list, in the order a session moves through the statuses.
 * `PublishedForTest` is not among them: it is never offered as a choice in the UI.
 */
export const storeStatusFilterOptions: { value: StoreStatusFilter; label: string }[] = [
  { value: 'all', label: 'shared.storeStatus.all' },
  { value: StoreStatus.Draft, label: storeStatusLabels[StoreStatus.Draft] },
  { value: StoreStatus.Published, label: storeStatusLabels[StoreStatus.Published] },
  { value: StoreStatus.Archived, label: storeStatusLabels[StoreStatus.Archived] },
];

export type StoreStatusBadgeTone = 'success' | 'warning' | 'info' | 'neutral';

export function storeStatusBadgeTone(status: StoreStatus): StoreStatusBadgeTone {
  switch (status) {
    case StoreStatus.Published:
      return 'success';
    case StoreStatus.PublishedForTest:
      return 'warning';
    case StoreStatus.Draft:
      return 'info';
    case StoreStatus.Archived:
    default:
      return 'neutral';
  }
}
